export const tabWidth = window.screen.width < 1000
 